export default __webpack_public_path__ + "static/media/bg13.dba64c69.jpg";